var _ = function _(t) {
    return t;
  },
  _t;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import css from './style.pcss';
import translations from './translations';
var RTLCalculator = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLCalculator, _LitElement);
  function RTLCalculator() {
    var _this;
    _classCallCheck(this, RTLCalculator);
    _this = _callSuper(this, RTLCalculator);
    _this.language = 'lu';
    _this.type = 'salaire';
    _this._value = 0;
    _this.percentage = 2.5;
    if (window.rtlsites) {
      _this.language = window.rtlsites.config.language;
    }
    return _this;
  }
  _createClass(RTLCalculator, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLCalculator.prototype), "connectedCallback", this).call(this);
    }
  }, {
    key: "value",
    get: function get() {
      return this._value;
    },
    set: function set(val) {
      var oldVal = this._value;
      this._value = Math.floor(val);
      this.requestUpdate('value', oldVal);
    }
  }, {
    key: "_getTranslation",
    value: function _getTranslation(key) {
      if (!translations[key]) {
        console.warn(key + ' is not defined in translations.js!');
      } else return translations[key][this.language];
    }
  }, {
    key: "_onValueChange",
    value: function _onValueChange(e) {
      this.value = e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
      this.shadowRoot.querySelector('#salaire').value = this.value;
    }
  }, {
    key: "render",
    value: function render() {
      return html(_t || (_t = _`
            <style>${0}</style>
            <div class="rtl-calculator">
                <div class="rtl-calculator__title">${0}</div>
                <div class="rtl-calculator__input"><input type="text" value="${0}" pattern="[0-9]+" placeholder="${0}" @input="${0}" id="salaire"/></div>
                <div class="rtl-calculator__index">${0}</div>
                <div class="rtl-calculator__result"><span>${0}</span></div>
            </div>
        `), css, this._getTranslation('salaire'), this.value, this.value, this._onValueChange, this._getTranslation('salaire-index'), new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR'
      }).format(this.value * (1 + this.percentage / 100)));
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        value: {
          type: Number
        },
        percentage: {
          type: Number
        },
        type: {
          type: String
        }
      };
    }
  }]);
  return RTLCalculator;
}(LitElement);
export { RTLCalculator as default };
window.customElements.define('rtl-calculator', RTLCalculator);